export default function LandSelect ({onChange, value}) {

    const countries = ["ישראלי", "אמריקאי"];

    const selectStyle = {
        "width" : "90%",
        "border" : "1px black solid",
        "borderRadius" : "3px"
    }


    return (
        <>
        <select style={selectStyle} value={value} onChange={onChange} >
            {countries.map((value, key) => <option value={value} key={key}> {value} </option>)};
        </select>
        </>
    )
}